module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/social/new/link-7b857d974d8e42fec75adc85a9451843.svg";